"use client";

import { Button } from "@/components/ui/Button";
import { useTranslations } from "@/i18n/client";
import styles from "./EmptyCart.module.css";

export const EmptyCart = () => {
	const t = useTranslations();
	return (
		<div>
			<h2 className={styles.header}>{t("Your cart is empty")}</h2>
			<p className={styles.text}>
				{t("Looks like you haven’t added anything to your cart yet")}
			</p>
			<Button
				data-testid="go-to-checkout-button"
				className={styles.button}
				href="/shop/kaos-klapp/klapp-high-chair"
			>
				{t("Start shopping")}
			</Button>
		</div>
	);
};
